import React, { PropsWithChildren } from 'react';
import PagesContextProvider from './modules/PagesContext';
import TrackingContextProvider from './modules/TrackingContext';

export const TimelineContext = (props : PropsWithChildren) => {
    return (
        <PagesContextProvider>
            <TrackingContextProvider>
                {props.children}
            </TrackingContextProvider>
        </PagesContextProvider>
    );
};
